module.exports = __webpack_public_path__ + "img/close.f97752ea.svg";